import axios from '@/axios';
import { COMEIN_URL } from '@/utils/host';
import { OSS_FILE_TYPE } from '@/utils/enum';

export const getOssSignature = fileType => {
	return axios.post(`${COMEIN_URL}/platform/json/oss/signature`, { fileType });
};

/**
 *
 * @param {*} file formData 文件
 * @param {string=} fileType  类型参考 OSS_FILE_TYPE
 * @param {boolean=} mediaToNormal 是否将音视频文件转换为普通文件上传
 * @returns
 */
export const uploadFileToOss = async (file, fileType, mediaToNormal = false) => {
	// 判断文件是否为空
	if (!file) return Promise.reject('文件不能为空');
	// 如果传入了fileType，则判断fileType是否合法
	if (fileType && !OSS_FILE_TYPE.includes(fileType)) return Promise.reject('OSS目录类型错误');
	// 如果没有传入fileType，则根据文件名来获取对应的fileType
	if (!fileType) {
		const arr = file.name.split('.');
		fileType = transferFileType(arr[arr.length - 1]?.toLowerCase(), mediaToNormal);
	}
	// 获取oss签名
	const { data } = await getOssSignature(fileType);
	const fileName = '.' + file?.name?.split('.')?.pop();
	const { dir, policy, accessid, callback, signature, host, acceleratehost } = data.data;
	// 上传文件
	const targetHost = acceleratehost || host;
	const res = await axios.post(
		targetHost,
		{
			key: dir + fileName,
			policy: policy,
			OSSAccessKeyId: accessid,
			callback: callback,
			signature: signature,
			file
		},
		{
			bodyType: 'file'
		}
	);

	// 返回结果
	return res;
};

export const transferFileType = (fileType, mediaToNormal = false) => {
	if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(fileType)) return 'img';
	if (['doc', 'docx'].includes(fileType)) return 'doc';
	if (['xls', 'xlsx'].includes(fileType)) return 'xls';
	if (['ppt', 'pptx'].includes(fileType)) return 'ppt';
	// if(['pdf'].includes(fileType)) return 'pdf';
	if (['mp3', 'wav', 'wma', 'ogg', 'ape', 'flac', 'opus'].includes(fileType))
		return mediaToNormal ? 'normal' : 'audio';
	if (['mp4', 'avi', 'rmvb', 'rm', 'flv', '3gp', 'mkv', 'mov', 'm4a'].includes(fileType))
		return mediaToNormal ? 'normal' : 'video';
	return 'normal';
};
